<template>
    <v-row v-if="left" :align="(isSmDevice)?'':'center'" no-gutters class="white" :class="rowClass" :style="style"> 
        <v-col cols="12" :md="mdSizeImage">
            <router-link v-if="to" :to="to">
                <v-img :src="image" :lazy-src="thumb" :scale="scaleText" :height="sectionHeight"></v-img>
            </router-link>
            <v-img v-else :src="image" :lazy-src="thumb" :scale="scaleText" :height="sectionHeight"></v-img>
        </v-col>  
        <v-col cols="12" :md="mdSizeText">
            <FullWidthCaptionWithText :txtClass="txtClass" :scale="scaleText" :title="title" :subTitle="subTitle" :maxWidth="maxWidth" :fontSize="fontSize">
                <slot ></slot>
            </FullWidthCaptionWithText>
        </v-col>
    </v-row>
    <v-row v-else :align="(isSmDevice)?'':'center'" no-gutters class="white" :class="rowClass" :style="style"> 
        <v-col cols="12" :md="mdSizeText" >
            <FullWidthCaptionWithText :txtClass="txtClass" :scale="scaleText" :title="title" :subTitle="subTitle" :maxWidth="maxWidth" :fontSize="fontSize">
                <slot ></slot>
            </FullWidthCaptionWithText>
        </v-col>
         <v-col cols="12" :md="mdSizeImage">
             <router-link v-if="to" :to="to">
                <v-img :src="image" :lazy-src="thumb" :scale="scaleText" :height="sectionHeight"></v-img>
            </router-link>
            <v-img v-else :src="image" :lazy-src="thumb" :scale="scaleText" :height="sectionHeight"></v-img>
        </v-col>  
    </v-row>
</template>

<script>
    import {layoutMixin} from '@/utils/layout-mixin'
    import FullWidthCaptionWithText from '@/components/blocks/FullWidthCaptionWithText.vue'
    export default {
        mixins:[layoutMixin],
        components:{
            FullWidthCaptionWithText
        },
        props: {
            title:{
                type:String
            },
            subTitle:{
                type:String
            },
            scale: {
                type: Number,
                default: 0.6
            },
            scaleText:{
                type: Number,
                default: 0.8
            },
            fontSize:{
                type: String,
                default: "6em"
            },
            image:{
                type:String
            },
            thumb:{
                type:String
            },
            to:{
                type:String
            },
            left:{
                type:Boolean,
            },
            right:{
                type:Boolean,
            },
            small:{
                type:Boolean,
            },
            medium:{
                type:Boolean,
            },
            large:{
                type:Boolean,
            },
            maxWidth:{
                type:String,
                default:"800px"
            },
            txtClass:{
                type:String
            },
            rowClass:{
                type:String
            }
        },
        computed: {
            style(){
                return {
                    
                }
            },
            sectionHeight(){
                return (this.scale*this.bgHeight);
            },
            mdSizeImage(){
                if(this.small){
                    return 3;
                }else if(this.medium){
                    return 5
                }else if(this.large){
                    return 7
                }
                return 6;
            },
            mdSizeText(){
                return 12-this.mdSizeImage;
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>